import React from "react";
import { Link } from "react-router-dom";
import { MonitorUp, PhoneCall, Users } from "lucide-react";

const ConferenceHub = () => (
    <main className="crm-shell">
        <header className="crm-header">
            <span className="eyebrow">Conf</span>
            <h1>Звонки, комнаты и демонстрация экрана</h1>
            <p>Текущая звонилка остаётся доступной отдельно от CRM. Следующий шаг: полноценные ссылки вида `/conf/:roomId`, приглашения и история комнаты.</p>
        </header>

        <section className="crm-module-grid">
            <article className="crm-module">
                <PhoneCall size={20} />
                <div>
                    <h2>1:1 calls</h2>
                    <p>Звонки контакту с ответом/отклонением, чатом, файлами, устройствами и демонстрацией экрана.</p>
                </div>
            </article>
            <article className="crm-module">
                <Users size={20} />
                <div>
                    <h2>Групповые звонки</h2>
                    <p>Небольшие mesh-комнаты с общим чатом, файлами и демонстрацией экрана.</p>
                </div>
            </article>
            <article className="crm-module">
                <MonitorUp size={20} />
                <div>
                    <h2>Комнаты по ссылке</h2>
                    <p>Следующий инкремент: постоянные комнаты `/conf/:roomId`, приглашения и история.</p>
                </div>
            </article>
        </section>

        <div className="conf-action-row">
            <Link className="primary-action conf-action" to="/dashboard">Открыть текущую звонилку</Link>
        </div>
    </main>
);

export default ConferenceHub;
